import { Box, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import TruckListItem from "../../../common/list-item/TruckListItem";
import { useDashLayoutCtx } from "../DashLayoutCtxProvider";
import useNetworkRequest from "../../../../hooks/NetworkRequest";
import { ENDPOINTS, urlWithPrefix } from "../../../../configs/APIConfig";
import { useNavigate } from "react-router-dom";
import LoadingScreen from "../../generic-screens/loading/LoadingScreen";
import notify from "../../../../funcs/ToastFuncs";
import SleepImage from "../../../../assets/svgs/sleep.svg";

const NoActTracking = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
    }}
  >
    <Box
      sx={{
        height: "300px",
        width: "300px",
        overflow: "hidden",
        backgroundImage: `url(${SleepImage})`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    />
    <Typography
      fontSize={"1.2rem"}
      fontWeight={500}
      sx={{
        mt: "20px",
      }}
    >
      No active trackings!
    </Typography>
    <Typography fontSize={"1rem"} fontWeight={400} sx={{ opacity: "0.6" }}>
      Start by creating a new tracking from trucks section.
    </Typography>
  </Box>
);

function ActiveTrackingList() {
  const {
    splitView,
    setexpandedView,
    transferBin,
    settransferBin,
    preloadVehTracking,
    setpreloadVehTracking,
  } = useDashLayoutCtx();
  const { fetchData } = useNetworkRequest();
  const abortControllerRef = useRef(null);
  const [actTrackingList, setactTrackingList] = useState([]);
  const [isFetching, setisFetching] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    getActTrackingList();
    // eslint-disable-next-line
  }, []);

  const navToErrorScreen = () => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    navigate("/error", {
      state: {
        releaseProtection: true,
      },
    });
  };

  //logic for preloading
  useEffect(() => {
    if (actTrackingList?.length > 0) {
      if (preloadVehTracking && preloadVehTracking?.vehRegNo) {
        let vehicle = actTrackingList.find(
          (item) => item.veh_no === preloadVehTracking?.vehRegNo
        );
        if (vehicle) {
          settransferBin({
            id: 0,
            vehRegNo: vehicle.veh_no,
            ownerName: vehicle.owner_name,
            mnfcName: vehicle.manufacturer,
          });
          setexpandedView(true);
          notify("Opening tracking: " + preloadVehTracking?.vehRegNo);
        } else {
          notify(
            preloadVehTracking?.vehRegNo + " not in your active tracking list."
          );
        }
        setpreloadVehTracking(null);
      }
    }
    // eslint-disable-next-line
  }, [actTrackingList]);

  const getActTrackingList = async () => {
    setisFetching(true);
    setactTrackingList([]);
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    const abortController = new AbortController();
    abortControllerRef.current = abortController;
    try {
      const resp = await fetchData({
        url: urlWithPrefix(
          ENDPOINTS.DASHBOARD.TRACKING.GET_ACTIVE_TRACKING.url
        ),
        method: ENDPOINTS.DASHBOARD.TRACKING.GET_ACTIVE_TRACKING.method,
        authRequired: true,
        timeout: 20000, // 20 Sec timeout
        signal: abortController.signal,
      });
      if (resp?.status === 200) {
        setactTrackingList(resp?.data?.data || []);
      } else {
        throw new Error("Failed to fetch active tracking list");
      }
    } catch (error) {
      if (error.code !== "ERR_CANCELED") {
        navToErrorScreen();
      }
    }
    setisFetching(false);
  };

  const onListItemClick = (obj) => {
    if (!transferBin || transferBin?.vehRegNo !== obj.vehRegNo) {
      settransferBin(obj);
      setexpandedView(true);
    }
  };
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
      }}
    >
      {actTrackingList &&
        actTrackingList.map((item, index) => (
          <TruckListItem
            key={index}
            vehRegNo={item.veh_no}
            ownerName={item.owner_name}
            mnfcName={item.manufacturer}
            id={item.id}
            onClickFunc={onListItemClick}
            selectedItem={transferBin?.vehRegNo === item.veh_no}
            compactMode={splitView ? true : false}
            hideDivider={index === actTrackingList.length - 1}
          />
        ))}
      {isFetching && <LoadingScreen containedMode />}
      {!isFetching && actTrackingList?.length === 0 && <NoActTracking />}
    </Box>
  );
}

export default ActiveTrackingList;
